/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OpenVulnerabilitiesBySeverityWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("OpenVulnerabilitiesBySeverityWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return OpenVulnerabilitiesBySeverityWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<OpenVulnerabilitiesBySeverityWidgetConfiguration>): OpenVulnerabilitiesBySeverityWidgetConfiguration {
        let obj = Object.assign(new OpenVulnerabilitiesBySeverityWidgetConfiguration(), model);
        OpenVulnerabilitiesBySeverityWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OpenVulnerabilitiesBySeverityWidgetConfiguration>): OpenVulnerabilitiesBySeverityWidgetConfiguration {
        if (!model) return null;
        return OpenVulnerabilitiesBySeverityWidgetConfiguration.newInstance(<OpenVulnerabilitiesBySeverityWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OpenVulnerabilitiesBySeverityWidgetConfiguration) {
        if (!obj) return;

        models.OpenVulnerabilitiesBySeverityWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OpenVulnerabilitiesBySeverityWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, OpenVulnerabilitiesBySeverityWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
